import * as Sentry from '@sentry/react'

const DEPLOYED_ENVIRONMENTS = ['Test', 'Staging', 'production']

function beforeSend (event: Sentry.ErrorEvent): Sentry.ErrorEvent | null {
  if (event.request) {
    delete event.request.cookies
    delete event.request.headers
  }
  return event
}

export function initSentry (): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  const environment = import.meta.env.VITE_SENTRY_ENVIRONMENT

  if (!dsn || !environment || !DEPLOYED_ENVIRONMENTS.includes(environment)) {
    return
  }

  const release = import.meta.env.VITE_SENTRY_RELEASE

  Sentry.init({
    dsn,
    environment,
    release: release || undefined,
    tracesSampleRate: 0,
    beforeSend,
    initialScope: {
      tags: { component: 'udc-new' }
    }
  })
}

type ApiErrorContext = {
  endpoint: string
  status?: number
}

export function captureApiError (error: unknown, context: ApiErrorContext): void {
  if (!import.meta.env.VITE_SENTRY_DSN) return

  Sentry.withScope((scope) => {
    scope.setTag('errorSource', 'api')
    scope.setContext('api', context)
    Sentry.captureException(error)
  })
}

export { Sentry }
